import React from "react";
import Dashboard from "../../Dashboard";
import Notifications from "../../../../features/userDashboard/notifications/Notifications";

const NotificationsPage = () => {
  return (
    <Dashboard
      title="Notifications"
      description="Manage your notifications and stay updated"
    >
      <Notifications />
    </Dashboard>
  );
};

export default NotificationsPage;
